import { union, filter } from 'lodash/fp';
import { PATH_BUILDER } from 'constants/actionTypes';

// composing type/id because _.union only works with primitive types
const composeId = action => `${action.contentType}.${action.id}`;

export default (loadingContent = [], action) => {
  switch (action.type) {
    case PATH_BUILDER.CONTENT.LOADING_CONTENTS_REQUEST:
      return union([composeId(action)], loadingContent);

    case PATH_BUILDER.CONTENT.LOADING_CONTENTS_SUCCESS:
      return filter(id => id !== composeId(action))(loadingContent);

    default:
      return loadingContent;
  }
};
